<button #button [type]="type" [class]="class" [disabled]="isDisabled" (click)="onButtonClick($event)" [attr.data-test]="testAttribute">
  <lib-icon *ngIf="prefixIcon" [name]="prefixIcon"></lib-icon>
  <span #content role="button">
    <ng-content></ng-content>
  </span>
  <lib-icon *ngIf="suffixIcon" [name]="suffixIcon"></lib-icon>
  <div *ngIf="badgeText" class="badge" [class]="badgeClass">{{badgeText}}</div>
</button>
